export const config = {
  bazerAPI: 'https://auth.bazerwallet.com',
  p2pAPI: 'https://api.bazer-p2p-loans.com',
  applicationCode: 'bazer_srv_7f4c2a91d8e34ab6b19f5c8d2e7a4f91c3b6d8e2f5a9c1b4d7e8f2a6c9b3d1'
}